import {
  BookOpen,
  Boxes,
  Briefcase,
  ChefHat,
  Flower2,
  Sofa,
  Umbrella,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

/**
 * Set inicial de 8 salas (docs/MVP.md §5). Cada sala es icono + color + etiqueta —
 * `fg` es el color de texto/icono con contraste AA verificado sobre `--color-room-*`
 * (ver docs/art-direction.md, tabla de contraste). Nunca uses el color de sala solo.
 */
export type RoomKey =
  | 'biblioteca'
  | 'cocina'
  | 'sotano'
  | 'terraza'
  | 'salon'
  | 'jardin'
  | 'despacho'
  | 'buhardilla';

export interface RoomDef {
  key: RoomKey;
  label: string;
  icon: LucideIcon;
  colorVar: string;
  fg: 'ink' | 'paper';
}

export const ROOMS: RoomDef[] = [
  {
    key: 'biblioteca',
    label: 'Biblioteca',
    icon: BookOpen,
    colorVar: 'var(--color-room-biblioteca)',
    fg: 'ink',
  },
  {
    key: 'cocina',
    label: 'Cocina',
    icon: ChefHat,
    colorVar: 'var(--color-room-cocina)',
    fg: 'paper',
  },
  {
    key: 'sotano',
    label: 'Sótano',
    icon: Warehouse,
    colorVar: 'var(--color-room-sotano)',
    fg: 'paper',
  },
  {
    key: 'terraza',
    label: 'Terraza',
    icon: Umbrella,
    colorVar: 'var(--color-room-terraza)',
    fg: 'paper',
  },
  {
    key: 'salon',
    label: 'Salón',
    icon: Sofa,
    colorVar: 'var(--color-room-salon)',
    fg: 'paper',
  },
  {
    key: 'jardin',
    label: 'Jardín',
    icon: Flower2,
    colorVar: 'var(--color-room-jardin)',
    fg: 'ink',
  },
  {
    key: 'despacho',
    label: 'Despacho',
    icon: Briefcase,
    colorVar: 'var(--color-room-despacho)',
    fg: 'paper',
  },
  {
    key: 'buhardilla',
    label: 'Buhardilla',
    icon: Boxes,
    colorVar: 'var(--color-room-buhardilla)',
    fg: 'paper',
  },
];
